import React, { PureComponent } from 'react';
import { func, string } from 'prop-types';

export default class TextInput extends PureComponent {
  static propTypes = {
    onChange: func.isRequired,
    onBlur: func,
    onEnterKey: func,
    value: string.isRequired,
  };

  filterEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (this.props.onEnterKey) {
        this.props.onEnterKey();
      }
    }
  };

  render() {
    return (
      <input
        className="input is-rounded"
        type="text"
        placeholder="Cerca"
        value={this.props.value}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        onKeyPress={this.filterEnterKeyPress}
      />
    );
  }
}

TextInput.displayName = 'TextInput';
